export enum BannerTypes {
    CHRISTMAS = 'LrdkvLykMORgKujVLwMm',
    SHE_AND_HER='GsEjyQxszNIerUkHtW3N',
    GLASSES_PROMO='v7tvb0bb8SgsbxYeaTJY',
    MOTHERS_DAY='NErIXaOR5moxD2McMm6S'
}